module.exports = "data:image/svg+xml;base64,PHN2ZyBpZD0iTGF5ZXJfMSIgZGF0YS1uYW1lPSJMYXllciAxIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyNCAyNCI+PHRpdGxlPmZvcndhcmQtbGluZTwvdGl0bGU+PHBhdGggZD0iTTksMjBhLjUuNSwwLDAsMS0uMzctLjE2LjUxLjUxLDAsMCwxLDAtLjcxTDE2LjI3LDEyLDguNjYsNC44N2EuNS41LDAsMCwxLC42OC0uNzRsOCw3LjVhLjUxLjUxLDAsMCwxLDAsLjc0bC04LDcuNUEuNDguNDgsMCwwLDEsOSwyMFoiLz48L3N2Zz4="


//////////////////
// WEBPACK FOOTER
// ./static/img/forward-line.svg
// module id = 95
// module chunks = 1